import { InjectionToken } from '@angular/core';

import type { OverviewPageAPI } from '@core/dashboard-types';

export const OVERVIEW_PAGE_API = new InjectionToken<OverviewPageAPI>('OverviewPageAPI');
